var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from 'react'; // tslint:disable-line
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
export var FieldDescriptionDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    font-family: ", ";\n    line-height: 1.35em;\n    margin: ", " 0 ", ";\n    color: ", ";\n    padding-left: ", ";\n    padding-top: 1px;\n    padding-bottom: 2px;\n    margin-left: 0px;\n    border-left: 2px solid ", ";\n\n    ", "\n  "], ["\n    font-size: ", ";\n    font-family: ", ";\n    line-height: 1.35em;\n    margin: ", " 0 ", ";\n    color: ", ";\n    padding-left: ", ";\n    padding-top: 1px;\n    padding-bottom: 2px;\n    margin-left: 0px;\n    border-left: 2px solid ", ";\n\n    ", "\n  "])), theme.FONT_SIZE(12), theme.FONT('app'), theme.UNIT(1.5), theme.UNIT(0.5), theme.COLOR('text-subtle'), theme.UNIT(3), theme.COLOR('line-subtle'), function (props) {
    return props.pad && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-top: 6px;\n      padding-bottom: 8px;\n    "], ["\n      padding-top: 6px;\n      padding-bottom: 8px;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var FieldDescription = function (props) {
  var className = props.className,
    children = props.children,
    field = props.field;
  return React.createElement(My.Container, {
    className: className
  }, children);
};
FieldDescription.defaultProps = FieldDescriptionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;